import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '@/store';
import DashboardHome from '@/components/dashboard/DashboardHome';
import routes from '@/routes/routes.json';

/**
 * Route guard around the home screen. A vendor who hasn't finished address or
 * bank details can't do anything useful here, so they go back to onboarding
 * rather than landing on a dashboard full of zeroes.
 */
const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { isAddressCompleted, isBankDetailsCompleted, vendorProfile } = useSelector(
    (state: RootState) => state.profile,
  );

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(routes.login);
      return;
    }
    if (vendorProfile?.payload && (!isAddressCompleted || !isBankDetailsCompleted)) {
      navigate(routes.vendorOnboard);
    }
  }, [isAuthenticated, isAddressCompleted, isBankDetailsCompleted, vendorProfile?.payload, navigate]);

  return <DashboardHome />;
};

export default Dashboard;
